/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_Theme_GloballyInputs */

const en_apply_theme_globally = /** @type {(inputs: Apply_Theme_GloballyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply Theme Globally`)
};

const es_apply_theme_globally = /** @type {(inputs: Apply_Theme_GloballyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar tema globalmente`)
};

const fr_apply_theme_globally = /** @type {(inputs: Apply_Theme_GloballyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appliquer le thème globalement`)
};

const de_apply_theme_globally = /** @type {(inputs: Apply_Theme_GloballyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design global anwenden`)
};

const ja_apply_theme_globally = /** @type {(inputs: Apply_Theme_GloballyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テーマを全体に適用`)
};

const zh_apply_theme_globally = /** @type {(inputs: Apply_Theme_GloballyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全局应用主题`)
};

const ar_apply_theme_globally = /** @type {(inputs: Apply_Theme_GloballyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تطبيق السمة عالميًا`)
};

const id_apply_theme_globally = /** @type {(inputs: Apply_Theme_GloballyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terapkan Tema Secara Global`)
};

const it_apply_theme_globally = /** @type {(inputs: Apply_Theme_GloballyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applica tema globalmente`)
};

const ru_apply_theme_globally = /** @type {(inputs: Apply_Theme_GloballyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Применить тему глобально`)
};

const pt_apply_theme_globally = /** @type {(inputs: Apply_Theme_GloballyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar tema globalmente`)
};

const ko_apply_theme_globally = /** @type {(inputs: Apply_Theme_GloballyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전체에 테마 적용`)
};

/**
* | output |
* | --- |
* | "Apply Theme Globally" |
*
* @param {Apply_Theme_GloballyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const apply_theme_globally = /** @type {((inputs?: Apply_Theme_GloballyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_Theme_GloballyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_apply_theme_globally(inputs)
	if (locale === "es") return es_apply_theme_globally(inputs)
	if (locale === "fr") return fr_apply_theme_globally(inputs)
	if (locale === "de") return de_apply_theme_globally(inputs)
	if (locale === "ja") return ja_apply_theme_globally(inputs)
	if (locale === "zh") return zh_apply_theme_globally(inputs)
	if (locale === "ar") return ar_apply_theme_globally(inputs)
	if (locale === "id") return id_apply_theme_globally(inputs)
	if (locale === "it") return it_apply_theme_globally(inputs)
	if (locale === "ru") return ru_apply_theme_globally(inputs)
	if (locale === "pt") return pt_apply_theme_globally(inputs)
	return ko_apply_theme_globally(inputs)
});